import React, { useState, useEffect } from 'react';
import './default.css';
import styles from './App.module.css';
import './common/index.module.scss';
import SessionEndScreen from './components/session-end-screen/SessionEndScreen';
import { ScreensContext } from './contexts/screensContext';
import { TypeFormContext } from './contexts/typeFormContext';
import { isMobile } from './utils/common';
import { isHistoryEnabledCampaign } from './utils/screenHistory';
import LMDS from './pages/LM-D-S';
import LM4 from './pages/LM-4';
import Chesterfield6 from './pages/Chesterfield-6';
import Chesterfield4 from './pages/Chesterfield-4';
import PMNS from './pages/PMNS';
import PMNB from './pages/PMNB';
import PMNM from './pages/PMNM';
import PMNMS from './pages/PMNMS';
import { DataLayerEventProvider } from './contexts/dataLayerEventContext';
import BNDP4 from './pages/BND-P-4';
import BNDP6 from './pages/BND-P-6';
import BNDPM from './pages/BND-P-M';
import MLBT from './pages/MLB-T';
import MLBFT from './pages/MLB-F-T';
import PRL_S_6 from './pages/PRL_S_6';
import PRL_S_4 from './pages/PRL_S_4';
import PRL_V from './pages/PRL_V';
import PRL_S_6_Test from './pages/PRL_S_6_Test';
import PRL_S_4_Test from './pages/PRL_S_4_Test';
import PRL_V_Test from './pages/PRL_V_Test';
import MLBTTest from './pages/MLB-T-Test';
import MLBFTTest from './pages/MLB-F-T-Test';
import LMLM from './pages/LM-L-M';
import LM6 from './pages/LM-6';
import LMLGREEN from './pages/LM-L-Green';
import LMLPurple from './pages/LM-L-Pr';
import ChesRe from './pages/Ches-Re';
import MPMPR from './pages/MPM-PR';
import KV from './pages/KV';
import LMDSTest from './pages/LM-D-S-TEST';
import Chesterfield6Test from './pages/Ches-6-Test';
import Chesterfield4Test from './pages/Ches-4-Test';
import GHWS from './pages/GHW-S';
import PersonalDataPolicy from './pages/PersonalDataPolicy';
import HSTSS1 from './pages/HSTSS1';
import HSTSS2 from './pages/HSTSS2';
import BNDB from './pages/BND-B';
import BNDR from './pages/BND-R';
import LMB from './pages/LM-B';
import LMR from './pages/LM-R';
import MLBG from './pages/MLB-G';
import MLBR from './pages/MLB-R';
import MLBS from './pages/MLB-S';
import ChesO from './pages/Ches-O';
import ChesB from './pages/Ches-B';
import ChesSP from './pages/Ches-SP';
import ChesSR from './pages/Ches-SR';
import LMSP from './pages/LM-SP';
import LMSR from './pages/LM-SR';
import MLBTLE from './pages/MLB-T-LE';
import MLBFTLE from './pages/MLB-F-T-LE';
import KV2 from './pages/KV2';
import ChesONB from './pages/Ches-O-NB';
import LMSPL from './pages/LM-SPL';
import KV3 from './pages/KV3';
import ChesR from './pages/Ches-R';
import PRLALPE from './pages/PRL-A-LPE';
import PRLNLPE from './pages/PRL-N-LPE';
import PRLPLPE from './pages/PRL-P-LPE';
import PRLSLPE from './pages/PRL-S-LPE';
import PRLA from './pages/PRL-A';
import PRLS from './pages/PRL-S';
import PRLN from './pages/PRL-N';
import PRLP from './pages/PRL-P';
import PRLASS from './pages/PRL-A-SS';
import PRLSSS from './pages/PRL-S-SS';
import KV4 from './pages/KV4';
import Unsubscribe from './pages/Unsubscribe';
import SmsPRL from './pages/SmsPRL';
import SmsNonflv from './pages/SmsNonflv';
import MLBTtn from './pages/MLB-Ttn';
import ChesPrpl from './pages/Ches-Prpl';
import SmsMrl from './pages/SmsMrl';
import MRLKV from './pages/MRLKV';
import SmsChe from './pages/SmsChe';
import CheKV from './pages/CheKV';
import TestChallenges from './pages/Test-Challenges';
import PRLShASSL from './pages/PRL-Sh-A-SSL';
import PRLShSSSL from './pages/PRL-Sh-S-SSL';
import QrError from './pages/QrError';
import UnsubscribeMail from './pages/UnsubscribeMail';
import SmsMpm25 from './pages/SmsMpm25';
import SmsPrlReg from './pages/SmsPrlReg';
import KV3UA25 from './pages/KV3UA25';
import SmsPrlSh from './pages/SmsPrlSh';
import SmsLmLoft from './pages/SmsLmLoft';
import KV4UA25 from './pages/KV4UA25';
import UAHostess from './pages/UA-Hostess';
import UABrand from './pages/UA-Brand';
import SmsCheKs from './pages/SmsCheKs';
import MLBPrpl from './pages/MLB-Prpl';
import SmsMrlPrpl from './pages/SmsMrlPrpl';
import KV5 from './pages/KV5';
import SmsCmpFrmt from './pages/SmsCmpFrmt';
import SmsMrlKs from './pages/SmsMrlKs';
import SmsPrlCrt from './pages/SmsPrlCrt';
import LMFCR from './pages/LM-FC-R';
import LMFCB from './pages/LM-FC-B';
import SmsSP1 from './pages/SmsSP1';
import FeedbackScreen from './pages/Feedback';
import KV6 from './pages/KV6';
import SmsCheCmpct from './pages/SmsCheCmpct';
import KV7 from './pages/KV7';
import SmsLmFc from './pages/SmsLmFc';
import SmsChePrif from './pages/SmsChePrif';
import LeafsGamePage from './pages/LeafsGamePage';
import MPMB from './pages/MPM-B';
import MPMR from './pages/MPM-R';
import LuxuryExpertChallengeWithAdaptation from './common/challenge-component/luxury-expert-challenge-with-adaptation';
import SmsPrlCrtBlue from './pages/SmsPrlCrtBlue';
import BrandEdPrl1 from './pages/BrandEdPrl1';
import BrandEdPrl2 from './pages/BrandEdPrl2';
import BrandEdPrl3 from './pages/BrandEdPrl3';
import BrandEdPrl4 from './pages/BrandEdPrl4';
import SmsMPM20 from './pages/SmsMPM20';
import SmsMrl40 from './pages/SmsMrl40';
import EmailCheck from './pages/EmailCheck';
import UaPrlSL from './pages/26-PRL-S-L';
import UaPrlAL from './pages/26-PRL-A-L';
import SmsBond from './pages/SmsBond';
import Promoter from './pages/Promoter';
import UaPrlN from './pages/26-PRL-N';
import UaPrlA from './pages/26-PRL-A';
import UaPrlS from './pages/26-PRL-S';
import UaPrlP from './pages/26-PRL-P';
import LMFCR26 from './pages/26-LM-FC-R-100STD';
import LMFCB26 from './pages/26-LM-FC-B-100STD';
import SmsSoho from './pages/SmsSoho';
import SmsPrlLine from './pages/SmsPrlLine';
import KV1 from './pages/26-KV1';
import KV2UA26 from './pages/26-KV2';
import SmsLM100 from './pages/SmsLM100';
import SmsPrlRvmp from './pages/SmsPrlRvmp';
import SmsCheXl from './pages/SmsCheXl';
import PageFlowWrapper from './common/registration-flow-wrapper';
import PersonalCabinet from './pages/PersonalCabinet';
import TarotFlowWrapper from './common/tarot-flow-wrapper';
import CookieConsentFlowWrapper from './common/cookie-consent-flow-wrapper';
import SohoVibeFlowWrapper from './common/soho-vibe-flow-wrapper';
import SohoCookieConsentFlowWrapper from './common/soho-cookie-consent-flow-wrapper';
import NewReviewFlowScreen from './common/new-review-flow-screen';
import SmsPrlmS from './pages/SmsPrlmS';
import UaPrlSign from './pages/26-PRL-Sign';
import SmsFeedback from './pages/SmsFeedback';
import KV3UA26 from './pages/26-KV3';
import KV4UA26 from './pages/26-KV4';
import LMLFCP26 from './pages/26-LM-LFC-P';
import LMLFCB26 from './pages/26-LM-LFC-B';
import SmsLmSsl from './pages/SmsLmSsl';
import SmsPrlmIf from './pages/SmsPrlmIf';
import PRLShASSLNew from './pages/PRL-Sh-A-SSL-new';
import PRLShSSSLNew from './pages/PRL-Sh-S-SSL-new';
import PRL_S_6_New from './pages/PRL_S_6_new';
import PRL_S_4_New from './pages/PRL_S_4_new';
import SmsLmRvmp from './pages/SmsLmRvmp';
import SmsSohoRvmp from './pages/SmsSohoRvmp';
import SmsLm40 from './pages/SmsLm40';
import LM4Test from './pages/23UA-LM-4-test';
import LM6Test from './pages/23UA-LM-6-test';
import LMLPrTest from './pages/24UA-LM-L-Pr-test';
import LMSplTest from './pages/24UA-LM-Spl-test';
import UABrandMgm from './pages/Ua-Brand-MGM';

const getApp = (number, cb, params = {}) => {
  switch (number) {
    case 1:
      return <LMLM setAppNumber={cb} />;
    case 2:
      return <LM6 setAppNumber={cb} />;
    case 3:
      return <LMLGREEN setAppNumber={cb} />;
    case 4:
      return <LMLPurple setAppNumber={cb} />;
    case 5:
      return <ChesRe setAppNumber={cb} />;
    case 6:
      return <MPMPR setAppNumber={cb} />;
    case 7:
      return <KV setAppNumber={cb} />;
    case 8:
      return <GHWS setAppNumber={cb} />;
    case 8.1:
      return <GHWS setAppNumber={cb} />;
    case 9:
      return <PersonalDataPolicy setAppNumber={cb} />;
    case 10:
      return <HSTSS1 setAppNumber={cb} />;
    case 11:
      return <HSTSS2 setAppNumber={cb} />;
    case 12:
      return <BNDB setAppNumber={cb} />;
    case 13:
      return <BNDR setAppNumber={cb} />;
    case 14:
      return <LMB setAppNumber={cb} />;
    case 15:
      return <LMR setAppNumber={cb} />;
    case 16:
      return <MLBG setAppNumber={cb} />;
    case 17:
      return <MLBR setAppNumber={cb} />;
    case 18:
      return <MLBS setAppNumber={cb} />;
    case 19:
      return <ChesO setAppNumber={cb} />;
    case 20:
      return <ChesB setAppNumber={cb} />;
    case 21:
      return <ChesSP setAppNumber={cb} />;
    case 22:
      return <ChesSR setAppNumber={cb} />;
    case 23:
      return <LMSP setAppNumber={cb} />;
    case 24:
      return <LMSR setAppNumber={cb} />;
    case 25:
      return <MLBTLE setAppNumber={cb} />;
    case 26:
      return <MLBFTLE setAppNumber={cb} />;
    case 27:
      return <LMDS setAppNumber={cb} />;
    case 27.1:
      return <LMDSTest setAppNumber={cb} />;
    case 28:
      return <Chesterfield6 setAppNumber={cb} />;
    case 28.1:
      return <Chesterfield6Test setAppNumber={cb} />;
    case 29:
      return <Chesterfield4 setAppNumber={cb} />;
    case 29.1:
      return <Chesterfield4Test setAppNumber={cb} />;
    case 30:
      return <PMNS setAppNumber={cb} />;
    case 31:
      return <PMNB setAppNumber={cb} />;
    case 32:
      return <PMNM setAppNumber={cb} />;
    case 33:
      return <PMNMS setAppNumber={cb} />;
    case 34:
      return <BNDP4 setAppNumber={cb} />;
    case 35:
      return <BNDP6 setAppNumber={cb} />;
    case 36:
      return <BNDPM setAppNumber={cb} />;
    case 37:
      return <MLBT setAppNumber={cb} />;
    case 38:
      return <MLBFT setAppNumber={cb} />;
    case 39:
      return (
        <PageFlowWrapper>
          <PRL_S_6 setAppNumber={cb} />
        </PageFlowWrapper>
      );
    case 40:
      return (
        <PageFlowWrapper>
          <PRL_S_4 setAppNumber={cb} />
        </PageFlowWrapper>
      );
    case 41:
      return <PRL_V setAppNumber={cb} />;
    case 42:
      return <PRL_S_6_Test setAppNumber={cb} />;
    case 43:
      return <PRL_S_4_Test setAppNumber={cb} />;
    case 44:
      return <PRL_V_Test setAppNumber={cb} />;
    case 45:
      return <MLBTTest setAppNumber={cb} />;
    case 46:
      return <MLBFTTest setAppNumber={cb} />;
    case 47:
      return <LM4 setAppNumber={cb} />;
    case 48:
      return <KV2 setAppNumber={cb} />;
    case 49:
      return <ChesONB setAppNumber={cb} />;
    case 50:
      return <LMSPL setAppNumber={cb} />;
    case 51:
      return <KV3 setAppNumber={cb} />;
    case 52:
      return <ChesB setAppNumber={cb} />;
    case 53:
      return <ChesO setAppNumber={cb} />;
    case 54:
      return <ChesR setAppNumber={cb} />;
    case 55:
      return <PRLALPE setAppNumber={cb} />;
    case 56:
      return <PRLNLPE setAppNumber={cb} />;
    case 57:
      return <PRLPLPE setAppNumber={cb} />;
    case 58:
      return <PRLSLPE setAppNumber={cb} />;
    case 59:
      return <PRLA setAppNumber={cb} />;
    case 60:
      return <PRLS setAppNumber={cb} />;
    case 61:
      return <PRLN setAppNumber={cb} />;
    case 62:
      return <PRLP setAppNumber={cb} />;
    case 63:
      return <PRLASS setAppNumber={cb} />;
    case 64:
      return <PRLSSS setAppNumber={cb} />;
    case 65:
      return <KV4 setAppNumber={cb} />;
    case 66:
      return <Unsubscribe setAppNumber={cb} />;
    case 67:
      return <SmsPRL setAppNumber={cb} />;
    case 68:
      return <SmsNonflv setAppNumber={cb} />;
    case 69:
      return <MLBTtn setAppNumber={cb} />;
    case 70:
      return <ChesPrpl setAppNumber={cb} />;
    case 71:
      return <SmsMrl />;
    case 72:
      return <MRLKV />;
    case 73:
      return <SmsChe />;
    case 74:
      return <CheKV />;
    case 75:
      return <TestChallenges />;
    case 76:
      return <PRLShASSL />;
    case 77:
      return <PRLShSSSL />;
    case 78:
      return <QrError />;
    case 79:
      return <UnsubscribeMail />;
    case 80:
      return <SmsMpm25 />;
    case 81:
      return <SmsPrlReg />;
    case 82:
      return <KV3UA25 />;
    case 83:
      return <SmsPrlSh />;
    case 84:
      return <SmsLmLoft />;
    case 85:
      return <KV4UA25 />;
    case 86:
      return <UAHostess />;
    case 87:
      return <UABrand />;
    case 88:
      return <SmsCheKs />;
    case 89:
      return <MLBPrpl />;
    case 90:
      return <SmsMrlPrpl />;
    case 91:
      return <KV5 />;
    case 92:
      return <SmsCmpFrmt />;
    case 93:
      return <SmsMrlKs />;
    case 94:
      return <SmsPrlCrt />;
    case 95:
      return <LMFCR />;
    case 96:
      return <LMFCB />;
    case 97:
      return <SmsSP1 />;
    case 98:
      return <FeedbackScreen />;
    case 99:
      return <KV6 />;
    case 100:
      return <SmsCheCmpct />;
    case 101:
      return <KV7 />;
    case 102:
      return <SmsLmFc />;
    case 103:
      return <SmsChePrif />;
    case 104:
      return <LeafsGamePage />;
    case 105:
      return <MPMB />;
    case 106:
      return <MPMR />;
    case 107:
      return <LuxuryExpertChallengeWithAdaptation />;
    case 108:
      return <SmsPrlCrtBlue />;
    case 109:
      return <BrandEdPrl1 />;
    case 110:
      return <BrandEdPrl2 />;
    case 111:
      return <SmsMPM20 />;
    case 112:
      return <BrandEdPrl3 />;
    case 113:
      return <BrandEdPrl4 />;
    case 114:
      return <SmsMrl40 />;
    case 115:
      return <BrandEdPrl1 withoutTg />;
    case 116:
      return <BrandEdPrl2 withoutTg />;
    case 117:
      return <BrandEdPrl3 withoutTg />;
    case 118:
      return <BrandEdPrl4 withoutTg />;
    case 119:
      return <EmailCheck />;
    case 120:
      return <UaPrlSL />;
    case 121:
      return <UaPrlAL />;
    case 122:
      return <UaPrlN />;
    case 123:
      return <UaPrlA />;
    case 124:
      return <UaPrlS />;
    case 125:
      return <UaPrlP />;
    case 126:
      return <LMFCB26 />;
    case 127:
      return <LMFCR26 />;
    case 128:
      return <SmsBond />;
    case 129:
      return <Promoter />;
    case 130:
      return <SmsSoho />;
    case 131:
      return <SmsPrlLine />;
    case 132:
      return <KV1 />;
    case 133:
      return <SmsLM100 />;
    case 134:
      return <KV2UA26 />;
    case 135:
      return <SmsPrlRvmp />;
    case 136:
      return <SmsCheXl />;
    case 137:
      return <SmsPrlmS />;
    case 138:
      return <KV3UA26 />;
    case 139:
      return (
        <CookieConsentFlowWrapper>
          <TarotFlowWrapper>
            <LMLFCP26 />
          </TarotFlowWrapper>
        </CookieConsentFlowWrapper>
      );
    case 140:
      return (
        <CookieConsentFlowWrapper>
          <TarotFlowWrapper>
            <LMLFCB26 />
          </TarotFlowWrapper>
        </CookieConsentFlowWrapper>
      );
    case 141:
      return <SmsLmSsl />;
    case 142:
      return <PersonalCabinet />;
    case 143:
      return <UABrandMgm />;
    case 145:
      return <SmsPrlmIf />;
    case 146:
      return (
        <SohoCookieConsentFlowWrapper>
          <SohoVibeFlowWrapper
            renderReviewScreen={(exitReview, backToVibe) => (
              <NewReviewFlowScreen
                setScreenNumber={exitReview}
                handleBack={backToVibe}
              />
            )}
          >
            <PageFlowWrapper
              isDarkMode
              isWithoutRegistration
              initialFlowCompleted
            >
              <PRLShASSLNew setAppNumber={cb} />
            </PageFlowWrapper>
          </SohoVibeFlowWrapper>
        </SohoCookieConsentFlowWrapper>
      );
    case 147:
      return (
        <SohoCookieConsentFlowWrapper>
          <SohoVibeFlowWrapper
            renderReviewScreen={(exitReview, backToVibe) => (
              <NewReviewFlowScreen
                setScreenNumber={exitReview}
                handleBack={backToVibe}
              />
            )}
          >
            <PageFlowWrapper
              isDarkMode
              isWithoutRegistration
              initialFlowCompleted
            >
              <PRLShSSSLNew setAppNumber={cb} />
            </PageFlowWrapper>
          </SohoVibeFlowWrapper>
        </SohoCookieConsentFlowWrapper>
      );
    case 148:
      return (
        <SohoCookieConsentFlowWrapper>
          <SohoVibeFlowWrapper
            renderReviewScreen={(exitReview, backToVibe) => (
              <NewReviewFlowScreen
                setScreenNumber={exitReview}
                handleBack={backToVibe}
              />
            )}
          >
            <PageFlowWrapper
              isDarkMode
              isWithoutRegistration
              initialFlowCompleted
            >
              <PRL_S_6_New setAppNumber={cb} />
            </PageFlowWrapper>
          </SohoVibeFlowWrapper>
        </SohoCookieConsentFlowWrapper>
      );
    case 149:
      return (
        <SohoCookieConsentFlowWrapper>
          <SohoVibeFlowWrapper
            renderReviewScreen={(exitReview, backToVibe) => (
              <NewReviewFlowScreen
                setScreenNumber={exitReview}
                handleBack={backToVibe}
              />
            )}
          >
            <PageFlowWrapper
              isDarkMode
              isWithoutRegistration
              initialFlowCompleted
            >
              <PRL_S_4_New setAppNumber={cb} />
            </PageFlowWrapper>
          </SohoVibeFlowWrapper>
        </SohoCookieConsentFlowWrapper>
      );
    case 150:
      return <UaPrlSign />;
    case 151:
      return <SmsLmRvmp />;
    case 152:
      return <SmsSohoRvmp />;
    case 153:
      return <KV4UA26 />;
    case 154:
      return <SmsLm40 />;
    case 157:
      return <SmsFeedback />;
    case 158:
      return <LM4Test />;
    case 159:
      return <LM6Test />;
    case 160:
      return <LMLPrTest />;
    case 161:
      return <LMSplTest />;
    default:
      return <SessionEndScreen setAppNumber={cb} />;
  }
};

function App() {
  const [appNumber, setAppNumber] = useState(null);
  const [endSessionType, setEndSessionType] = useState('NOT_MOBILE');
  const [typeFormScreen, setTypeFormScreen] = useState('Смак та якість тютюну');
  const [isLocalQrCode, setIsQrCode] = useState(
    sessionStorage.getItem('isQrCode')
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const unsubscribeRedirect = urlParams.get('returnLink');
    const utm_campaign = urlParams.get('utm_campaign');
    const utm_event = urlParams.get('utm_event');
    const utm_medium = urlParams.get('utm_medium');
    const utm_source = urlParams.get('utm_source');
    const utm_source_id = urlParams.get('utm_source_id');
    const sku_name = urlParams.get('sku_name');
    const channel = urlParams.get('channel');
    const campaign_name = urlParams.get('campaign_name');
    const user_id = urlParams.get('user_id');

    if (utm_campaign) sessionStorage.setItem('utm_campaign', utm_campaign);
    if (utm_event) sessionStorage.setItem('utm_event', utm_event);
    if (utm_medium) sessionStorage.setItem('utm_medium', utm_medium);
    if (utm_source) sessionStorage.setItem('utm_source', utm_source);
    if (utm_source_id) sessionStorage.setItem('utm_source_id', utm_source_id);
    if (unsubscribeRedirect)
      sessionStorage.setItem('unsubscribeRedirect', unsubscribeRedirect);
    if (sku_name) sessionStorage.setItem('sku_name', sku_name);
    if (channel) sessionStorage.setItem('channel', channel);
    if (campaign_name) sessionStorage.setItem('campaign_name', campaign_name);
    if (user_id) sessionStorage.setItem('user_id', user_id);

    if (
      isLocalQrCode &&
      appNumber &&
      window.location.href.includes(isLocalQrCode)
    ) {
      //window.location.replace(window.location.origin);
    }
  }, [isLocalQrCode, appNumber]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const unsubscribeRedirect = urlParams.get('returnLink');
    const utm_campaign = urlParams.get('utm_campaign');
    const utm_event = urlParams.get('utm_event');
    const utm_medium = urlParams.get('utm_medium');
    const utm_source = urlParams.get('utm_source');
    const utm_source_id = urlParams.get('utm_source_id');
    const sku_name = urlParams.get('sku_name');
    const utm_partner = urlParams.get('utm_partner');
    const utm_token = urlParams.get('utm_token');

    sessionStorage.setItem('pathname', window.location.pathname);
    sessionStorage.setItem('search', window.location.search);
    if (utm_campaign) sessionStorage.setItem('utm_campaign', utm_campaign);
    if (utm_event) sessionStorage.setItem('utm_event', utm_event);
    if (utm_medium) sessionStorage.setItem('utm_medium', utm_medium);
    if (utm_source) sessionStorage.setItem('utm_source', utm_source);
    if (sku_name) sessionStorage.setItem('sku_name', sku_name);
    if (utm_source_id) sessionStorage.setItem('utm_source_id', utm_source_id);
    if (utm_partner) sessionStorage.setItem('utm_partner', utm_partner);
    if (utm_token) sessionStorage.setItem('utm_token', utm_token);
    if (unsubscribeRedirect)
      sessionStorage.setItem('unsubscribeRedirect', unsubscribeRedirect);

    const blockPopState = (event) => {
      if (event.state && typeof event.state.screenNumber === 'number') return;
      if (window.__screenHistoryActive || isHistoryEnabledCampaign()) return;
      event.preventDefault();
      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener('popstate', blockPopState);

    return () => {
      window.removeEventListener('popstate', blockPopState);
    };
  }, []);

  useEffect(() => {
    const utm_source_id = sessionStorage.getItem('utm_source_id');

    if (utm_source_id === '662765297') {
      setEndSessionType('OPEN_NOT_FROM_QR');
      setIsQrCode('');
      return setAppNumber(null);
    }

    if (
      !isMobile &&
      isLocalQrCode !== '24UA-hstss1' &&
      isLocalQrCode !== '24UA-hstss2' &&
      isLocalQrCode !== 'leafs-game' &&
      isLocalQrCode !== 'luxury-expert'
    ) {
      return setAppNumber(null);
    }

    switch (isLocalQrCode) {
      case '23UA-LM-L-M':
        return setAppNumber(1);
      case '23UA-LM-6':
        return setAppNumber(2);
      case '24UA-LM-L-Green':
        return setAppNumber(3);
      case '24UA-LM-L-Pr':
        return setAppNumber(4);
      case '24UA-Ches-Re':
        return setAppNumber(5);
      case '24UA-MPM-PR':
        return setAppNumber(6);
      case '24UA-KV':
        return setAppNumber(7);
      case '24UA-GHW-S':
        return setAppNumber(8);
      case '24UA-GHW-S-Test':
        return setAppNumber(8.1);
      case 'personal-data-policy':
        return setAppNumber(9);
      case '24UA-hstss1':
        return setAppNumber(10);
      case '24UA-hstss2':
        return setAppNumber(11);
      case '24UA-BND-B':
        return setAppNumber(12);
      case '24UA-BND-R':
        return setAppNumber(13);
      case '24UA-LM-B':
        return setAppNumber(14);
      case '24UA-LM-R':
        return setAppNumber(15);
      case '24UA-MLB-G':
        return setAppNumber(16);
      case '24UA-MLB-R':
        return setAppNumber(17);
      case '24UA-MLB-S':
        return setAppNumber(18);
      case '24UA-Ches-O':
        return setAppNumber(19);
      case '24UA-Ches-B':
        return setAppNumber(20);
      case '24UA-Ches-SP':
        return setAppNumber(21);
      case '24UA-Ches-SR':
        return setAppNumber(22);
      case '24UA-LM-SP':
        return setAppNumber(23);
      case '24UA-LM-SR':
        return setAppNumber(24);
      case '24UA-MLB-T-LE':
        return setAppNumber(25);
      case '24UA-MLB-F-T-LE':
        return setAppNumber(26);
      case '23UA-LM-D-S':
        return setAppNumber(27);
      case '23UA-LM-D-S-Test':
        return setAppNumber(27.1);
      case '23UA-Ches-6':
        return setAppNumber(28);
      case '23UA-Ches-6-test':
        return setAppNumber(28.1);
      case '23UA-Ches-4':
        return setAppNumber(29);
      case '23UA-Ches-4-test':
        return setAppNumber(29.1);
      case '23UA-MPM-4-Test':
        return setAppNumber(30);
      case '23UA-MPM-6-Test':
        return setAppNumber(31);
      case '23UA-MPM-N-M-Test':
        return setAppNumber(32);
      case '23UA-MPM-N-M-S-Test':
        return setAppNumber(33);
      case '23UA-MPM-4':
        return setAppNumber(30);
      case '23UA-MPM-6':
        return setAppNumber(31);
      case '23UA-MPM-N-M':
        return setAppNumber(32);
      case '23UA-MPM-N-M-S':
        return setAppNumber(33);
      case '23UA-BND-P-4-Test':
        return setAppNumber(34);
      case '23UA-BND-P-4':
        return setAppNumber(34);
      case '23UA-BND-P-6-Test':
        return setAppNumber(35);
      case '23UA-BND-P-6':
        return setAppNumber(35);
      case '23UA-BND-P-M-Test':
        return setAppNumber(36);
      case '23UA-BND-P-M':
        return setAppNumber(36);
      case '23UA-MLB-T-Test':
        return setAppNumber(45);
      case '23UA-MLB-T':
        return setAppNumber(37);
      case '23UA-MLB-F-T-Test':
        return setAppNumber(46);
      case '23UA-MLB-F-T':
        return setAppNumber(38);
      case '23UA-PRL-S-6-Test':
        return setAppNumber(42);
      case '23UA-PRL-S-4-Test':
        return setAppNumber(43);
      case '23UA-PRL-V-Test':
        return setAppNumber(44);
      case '23UA-PRL-S-Comp-Blue':
        return setAppNumber(39);
      case '23UA-PRL-S-4':
        return setAppNumber(40);
      case '23UA-PRL-V':
        return setAppNumber(41);
      case '23UA-LM-4':
        return setAppNumber(47);
      case '24UA-KV2':
        return setAppNumber(48);
      case '24UA-Ches-O-NB':
        return setAppNumber(49);
      case '24UA-LM-Spl':
        return setAppNumber(50);
      case '24UA-KV3':
        return setAppNumber(51);
      case '24UA-Ches-R':
        return setAppNumber(54);
      case '24UA-PRL-A-LPE':
        return setAppNumber(55);
      case '24UA-PRL-N-LPE':
        return setAppNumber(56);
      case '24UA-PRL-P-LPE':
        return setAppNumber(57);
      case '24UA-PRL-S-LPE':
        return setAppNumber(58);
        // case 'ua-prl?utm_campaign=24UA-PRL-A':
        //   return setAppNumber(59);
        // case 'ua-prl?utm_campaign=24UA-PRL-S':
        //   return setAppNumber(60);
        // case 'ua-prl?utm_campaign=24UA-PRL-N':
        //   return setAppNumber(61);
        // case 'ua-prl?utm_campaign=24UA-PRL-P':
        return setAppNumber(62);
      case '24UA-PRL-A-SS':
        return setAppNumber(63);
      case '24UA-PRL-S-SS':
        return setAppNumber(64);
      case '24UA-KV4':
        return setAppNumber(65);
      case 'unsubscribe':
        return setAppNumber(66);
      case '24-sms-prl':
        return setAppNumber(67);
      case '25-sms-nonflv':
        return setAppNumber(68);
      case '25UA-MLB-Ttn':
        return setAppNumber(69);
      case '25UA-Ches-Prpl':
        return setAppNumber(70);
      case '25-sms-mrl':
        return setAppNumber(71);
      case '25UA-KV1':
        return setAppNumber(72);
      case '25-sms-che':
        return setAppNumber(73);
      case '25UA-KV2':
        return setAppNumber(74);
      case 'test-challenges':
        return setAppNumber(75);
      case '25UA-PRL-Sh-A-SSL':
        return setAppNumber(76);
      case '25UA-PRL-Sh-S-SSL':
        return setAppNumber(77);
      case 'qr-error':
        return setAppNumber(78);
      case 'unsubscribe-mail':
        return setAppNumber(79);
      case '25-sms-mpm25':
        return setAppNumber(80);
      case '25-sms-prl-reg':
        return setAppNumber(81);
      case '25UA-KV3':
        return setAppNumber(82);
      case '25-sms-prl-sh':
        return setAppNumber(83);
      case '25-sms-lm-loft':
        return setAppNumber(84);
      case '25UA-KV4':
        return setAppNumber(85);
      case 'ua-hostess':
        return setAppNumber(86);
      case 'ua-mlb':
        return setAppNumber(87);
      case 'ua-bnd':
        return setAppNumber(87);
      case 'ua-mpm':
        return setAppNumber(87);
      case 'ua-lm':
        return setAppNumber(87);
      case 'ua-ch':
        return setAppNumber(87);
      case 'ua-prl':
        return setAppNumber(87);
      case 'ua-kv':
        return setAppNumber(87);
      case '25-sms-che-ks':
        return setAppNumber(88);
      case '24UA-MLB-Prpl':
        return setAppNumber(89);
      case '25-sms-mrl-prpl':
        return setAppNumber(90);
      case '25UA-KV5':
        return setAppNumber(91);
      case '25-sms-cmp-frmt':
        return setAppNumber(92);
      case '25-sms-mrl-ks':
        return setAppNumber(93);
      case '25-sms-prl-crt':
        return setAppNumber(94);
      case '25UA-LM-FC-R':
        return setAppNumber(95);
      case '25UA-LM-FC-B':
        return setAppNumber(96);
      case '25-sms-sp1':
        return setAppNumber(97);
      case 'feedback':
        return setAppNumber(98);
      case '25UA-KV6':
        return setAppNumber(99);
      case '25-sms-che-cmpct':
        return setAppNumber(100);
      case '25UA-KV7':
        return setAppNumber(101);
      case '25-sms-lm-fc':
        return setAppNumber(102);
      case '25-sms-che-prif':
        return setAppNumber(103);
      case 'leafs-game':
        return setAppNumber(104);
      case '25UA-MPM-B':
        return setAppNumber(105);
      case '25UA-MPM-R':
        return setAppNumber(106);
      case 'luxury-expert':
        return setAppNumber(107);
      case '25-sms-prl-crt-blue':
        return setAppNumber(108);
      case 'brand-ed-prl1':
        return setAppNumber(109);
      case 'brand-ed-prl2':
        return setAppNumber(110);
      case '25-sms-mpm-20':
        return setAppNumber(111);
      case 'brand-ed-prl3':
        return setAppNumber(112);
      case 'brand-ed-prl4':
        return setAppNumber(113);
      case '25-sms-mrl-40':
        return setAppNumber(114);
      case 'brand-ed-prl1-tg':
        return setAppNumber(115);
      case 'brand-ed-prl2-tg':
        return setAppNumber(116);
      case 'brand-ed-prl3-tg':
        return setAppNumber(117);
      case 'brand-ed-prl4-tg':
        return setAppNumber(118);
      case 'email_check':
        return setAppNumber(119);
      case 'ua-prl?utm_campaign=26UA-PRL-S-L':
        return setAppNumber(120);
      case 'ua-prl?utm_campaign=26UA-PRL-A-L':
        return setAppNumber(121);
      case 'ua-prl?utm_campaign=24UA-PRL-N':
        return setAppNumber(122);
      case 'ua-prl?utm_campaign=24UA-PRL-A':
        return setAppNumber(123);
      case 'ua-prl?utm_campaign=24UA-PRL-S':
        return setAppNumber(124);
      case 'ua-prl?utm_campaign=24UA-PRL-P':
        return setAppNumber(125);
      case '26UA-LM-FC-B-100STD':
        return setAppNumber(126);
      case '26UA-LM-FC-R-100STD':
        return setAppNumber(127);
      case '25-sms-bond':
        return setAppNumber(128);
      case 'ua-mlb?utm_campaign=PROMOTER':
      case 'ua-bnd?utm_campaign=PROMOTER':
      case 'ua-mpm?utm_campaign=PROMOTER':
      case 'ua-lm?utm_campaign=PROMOTER':
      case 'ua-ch?utm_campaign=PROMOTER':
      case 'ua-prl?utm_campaign=PROMOTER':
      case 'ua-kv?utm_campaign=PROMOTER':
        return setAppNumber(129);
      case '25-sms-soho':
        return setAppNumber(130);
      case '25-sms-prl-line':
        return setAppNumber(131);
      case 'ua-kv?utm_campaign=26UA-KV1':
        return setAppNumber(132);
      case '25-sms-lm-100':
        return setAppNumber(133);
      case 'ua-kv?utm_campaign=26UA-KV2':
        return setAppNumber(134);
      case '25-sms-prl-rvmp':
        return setAppNumber(135);
      case '25-sms-che-xl':
        return setAppNumber(136);
      case '25-sms-prlm-s':
        return setAppNumber(137);
      case 'ua-kv?utm_campaign=26UA-KV3':
        return setAppNumber(138);
      case 'ua-lm?utm_campaign=26UA-LM-LFC-P-100':
        return setAppNumber(139);
      case 'ua-lm?utm_campaign=26UA-LM-LFC-B-100':
        return setAppNumber(140);
      case '25-sms-lm-ssl':
        return setAppNumber(141);
      case '25-sms-prlm-if':
        return setAppNumber(145);
      case 'ua-prl?utm_campaign=25UA-PRL-Sh-A-SSL':
        return setAppNumber(146);
      case 'ua-prl?utm_campaign=25UA-PRL-Sh-S-SSL':
        return setAppNumber(147);
      case 'ua-prl?utm_campaign=23UA-PRL-S-Comp-Blue':
        return setAppNumber(148);
      case 'ua-prl?utm_campaign=23UA-PRL-S-4':
        return setAppNumber(149);
      case 'ua-prl?utm_campaign=26UA-PRL-Sign':
        return setAppNumber(150);
      case '25-sms-lm-rvmp':
        return setAppNumber(151);
      case '25-sms-soho-rvmp':
        return setAppNumber(152);
      case 'ua-kv?utm_campaign=26UA-KV4':
        return setAppNumber(153);
      case '25-sms-lm-40':
        return setAppNumber(154);
      case 'sms-feedback':
        return setAppNumber(157);
      case 'ua-lm?utm_campaign=23UA-LM-4':
        return setAppNumber(158);
      case 'ua-lm?utm_campaign=23UA-LM-6':
        return setAppNumber(159);
      case 'ua-lm?utm_campaign=24UA-LM-L-Pr':
        return setAppNumber(160);
      case 'ua-lm?utm_campaign=24UA-LM-Spl':
        return setAppNumber(161);
      case 'personalcabinet':
        return setAppNumber(142);
      case 'ua-mgm?utm_campaign=REGISTRATION':
        return setAppNumber(143);
      default:
        setEndSessionType('OPEN_NOT_FROM_QR');
        setAppNumber(null);
        setIsQrCode('');
        return;
    }
  }, [isLocalQrCode]);

  return (
    <div className={styles.appBox}>
      <TypeFormContext.Provider value={{ typeFormScreen, setTypeFormScreen }}>
        <ScreensContext.Provider value={{ endSessionType, setEndSessionType }}>
          <DataLayerEventProvider>
            {getApp(appNumber, setAppNumber)}
          </DataLayerEventProvider>
        </ScreensContext.Provider>
      </TypeFormContext.Provider>
    </div>
  );
}

export default App;
